import { Button, Step, Grid, Box } from "@mui/material";

import { useNavigate } from "react-router-dom";

import LoadingButton from "@mui/lab/LoadingButton";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import {
  PageWrapper,
  FormWrapper,
  FormContent,
  ActionBar,
  CompactStepper,
  NoLineConnector,
  PurpleStepLabel,
  FormDivider,
  StepDescription,
  StepTitle,
} from "./ChannelAddForm.styles";

export default function ChannelAddForm(props) {
  const navigate = useNavigate();

  const {
    steps,
    onSubmit,
    onSuccess = () =>
    navigate("/canais", {
      state: { shouldRefetch: true },
    }),
    onRetry = () => window.location.reload(),
    onSupport = () => window.open("https://wa.me/553121300297"),
    success,
    loading,
    currentStep,
    setCurrentStep,
    disableBack = false,
  } = props;

  const step = steps[currentStep - 1];

  const handleNext = () => {
    if (Array.isArray(onSubmit)) {
      onSubmit[currentStep - 1]?.();
    } else {
      onSubmit?.();
    }
  };

  const handleBack = () => {
    if (currentStep > 1 && !loading) setCurrentStep(currentStep - 1);
  };

  return (
    <PageWrapper>
      <Grid container justifyContent="center">
        <Grid item xs={12} display="flex" justifyContent="center">
          <FormWrapper>
            <FormContent>
              {/* STEPPER */}
              <CompactStepper
                activeStep={currentStep - 1}
                alternativeLabel
                connector={<NoLineConnector />}
              >
                {steps.map((_, i) => (
                  <Step key={i} completed={i < currentStep - 1}>
                    <PurpleStepLabel />
                  </Step>
                ))}
              </CompactStepper>

              <FormDivider />

              {/* TITLE */}
              <StepTitle variant="h6">{step.title}</StepTitle>

              {/* DESCRIPTION */}
              <StepDescription>{step.description}</StepDescription>

              {/* CUSTOM CONTENT DO STEP */}
              {step.content && <Box sx={{ mt: 2 }}>{step.content}</Box>}

              {/* FINAL STEP CONTENT */}
              {currentStep === steps.length && (
                <>
                  {success ? (
                    <Button
                      variant="outlined"
                      startIcon={
                        <CheckCircleOutlineIcon sx={{ color: "#000" }} />
                      }
                      onClick={onSuccess}
                      sx={{ mt: 2 }}
                    >
                      Verificar meus canais
                    </Button>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "10px",
                        flexWrap: "wrap",
                        mt: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        onClick={onSupport}
                        startIcon={<WhatsAppIcon />}
                      >
                        Falar com suporte
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={onRetry}
                        startIcon={<AutorenewIcon />}
                      >
                        Tentar novamente
                      </Button>
                    </Box>
                  )}
                </>
              )}
            </FormContent>

            {/* ACTION BAR */}
            <ActionBar>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                {/* BACK BUTTON */}
                <Grid item>
                  {currentStep > 1 &&
                  currentStep < steps.length &&
                  !loading &&
                  !disableBack ? (
                    <Button variant="text" onClick={handleBack}>
                      Voltar
                    </Button>
                  ) : (
                    <Box sx={{ width: "75px", height: "36px" }} />
                  )}
                </Grid>

                {/* NEXT BUTTON */}
                <Grid item>
                  {currentStep < steps.length ? (
                    <LoadingButton
                      loading={loading}
                      variant="contained"
                      sx={{ borderRadius: "9999px" }}
                      onClick={handleNext}
                    >
                      Avançar
                    </LoadingButton>
                  ) : (
                    <Box sx={{ width: "85px", height: "36px" }} />
                  )}
                </Grid>
              </Grid>
            </ActionBar>
          </FormWrapper>
        </Grid>
      </Grid>
    </PageWrapper>
  );
}
